<!-- <form> -->
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate-pulse" [fullScreen] = "true"><p style="color: white" > Processing... </p></ngx-spinner>
<app-customer-search (searchCustomer)="searchCustomer($event)"></app-customer-search>

<div class="card text-center" *ngIf="dataSource.data.length>0">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
      Dealer List
    </div>
    <div class="card-body mat-card">
      <div class="row">

        <div class="col-sm-12">
          <div class="col-sm-3 float-right   pb-2"><input type="text" class="form-control" (keyup)="doFilter($event)" placeholder="Filter">
          </div>
        </div>

        <div class="col-sm-12">
          <mat-table #table [dataSource]="dataSource" matSort matSortStart="desc">

            <!-- Name Column -->
            <ng-container matColumnDef="saleCode">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Sale Code </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.saleCode}} </mat-cell>
            </ng-container>


            <!-- Name Column -->
            <!-- <ng-container matColumnDef="serviceCode">
            <mat-header-cell mat-sort-header *matHeaderCellDef> Service Code </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.serviceCode}} </mat-cell>
          </ng-container> -->

            <!-- Position Column -->
            <ng-container matColumnDef="contact">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Contact Name </mat-header-cell>
              <mat-cell *matCellDef="let element" (click)="onContactClick(element)" class="btn-link text-primary"> {{element.contactName}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="companyName">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Company Name </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="contactPreference">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Contact Preference </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ (element.contactPreference |  contactPreferenceValuePipe:element)}} </mat-cell>
            </ng-container>


            <ng-container matColumnDef="saleRank">
              <mat-header-cell mat-sort-header *matHeaderCellDef> SaleRank / ServiceRank </mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{element.saleRank}} <b>&nbsp; / &nbsp;</b> {{element.serviceRank}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="CustomerListHeader"></mat-header-row>
            <mat-row *matRowDef="let row; columns: CustomerListHeader;"></mat-row>
          </mat-table>
        </div>
        <div class="col-sm-12">
          <div class="col-sm-6 float-right text-right">
            <mat-paginator [length]="100" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
          </div>
        </div>
      </div>


      <!-- <table class="table table-bordered" *ngIf="CustomerList.length>0">
        <thead>
          <tr>
            <th scope="col" *ngFor="let headerName of CustomerListHeader" class="text-capitalize">{{headerName}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let customer of CustomerList" >
            <td> {{customer.saleCode}} </td>
            <td> {{customer.serviceCode}} </td>
            <td> {{customer.companyName}} </td>
            <td> {{customer.contactName}} </td>
            <td> {{(customer.contactPreference | contactPreferenceValuePipe:customer)}} </td>

          </tr>
         
        </tbody>
      </table> -->

    </div>




  </div>
<!-- </form> -->
